import { render, staticRenderFns } from "./addEntityupdate.vue?vue&type=template&id=74da0c06&scoped=true"
import script from "./addEntityupdate.vue?vue&type=script&lang=js"
export * from "./addEntityupdate.vue?vue&type=script&lang=js"
import style0 from "./addEntityupdate.vue?vue&type=style&index=0&id=74da0c06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74da0c06",
  null
  
)

export default component.exports